var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.2431 15.743c1.6568 0 3-1.3432 3-3v-2.25c0-.414-.336-.74997-.75-.74997s-.75.33597-.75.74997v2.25c0 .8288-.6712 1.5-1.5 1.5h-5.99994c-.82875 0-1.5-.6712-1.5-1.5v-5.99996c0-.82875.67125-1.5 1.5-1.5h2.25c.41399 0 .74999-.336.74999-.75s-.336-.75-.74999-.75h-2.25c-1.65675 0-3 1.34325-3 3v5.99996c0 1.6568 1.34325 3 3 3zm-2.99995-5.25c.192 0 .39225-.0645.53925-.2107l5.4607-5.4615v2.67224h1.5v-4.5c0-.414-.336-.75-.75-.75h-4.5v1.5h2.6715l-5.4607 5.46074c-.29249.29325-.29249.78525 0 1.07852.147.1462.34725.2107.53925.2107z",
    fill: "#5200ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkHome);
export default __webpack_public_path__ + "static/media/linkHome.68ec9f0390cb531cdc89c260c4374fe4.svg";
export { ForwardRef as ReactComponent };